import { render, staticRenderFns } from "./SendRequestAction.vue?vue&type=template&id=2b9d9d5c&"
import script from "./SendRequestAction.vue?vue&type=script&lang=js&"
export * from "./SendRequestAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports